<template>
  <component :is="managerCardType" :manager-info="accountManagerInfo" />
</template>

<script>
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'
  import ManagerMainCard from '@/components/PersonalManagerCard/ManagerMainCard.vue'
  import ManagerCompactCard from '@/components/PersonalManagerCard/ManagerCompactCard.vue'
  import defaultAvatar from '@/assets/support.jpg'

  export default {
    name: 'PersonalManagerCard',
    components: { ManagerCompactCard, ManagerMainCard },
    props: {
      isCompact: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        defaultAvatar
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['adNetwork']),
      managerCardType() {
        return this.isCompact ? ManagerCompactCard : ManagerMainCard
      },
      accountManagerInfo() {
        const manager = {
          name: this.adNetwork.settings.defaultAccountManager.name,
          avatar: this.adNetwork.settings.defaultAccountManager.avatar || this.defaultAvatar,
          messengers: this.adNetwork.settings.defaultAccountManager.messengers || [],
          description: this.isCompact ? this.$t('main.message_us_anytime') : this.$t('main.feel_free_message')
        }
        const userManager = this.$auth.user?.account_manager
        if (userManager) {
          manager.name = userManager.first_name
          manager.avatar = userManager.avatar || this.defaultAvatar
          manager.messengers = userManager.messengers || []
          manager.description = this.isCompact ? this.$t('main.your_personal_manager') : this.$t('main.im_personal_manager')
        }
        return manager
      }
    }
  }
</script>
